const u = (id) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400`;
const p = (id) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=1400`;
const g = (h) => `https://static.prod-images.emergentagent.com/jobs/dd7b4901-0aa8-42e0-9fa7-305e497a1e26/images/${h}.jpeg`;

export const IMG = {
  moon: g("031d99ceb387d527cf95526d958b93c373d26923dfca4b9a9b5731e4cc2c7f72"),
  rack: u("photo-1680691257251-5fead813b73e"),
  cables: u("photo-1683322499436-f4383dd59f5a"),
  camera: u("photo-1528312635006-8ea0bc49ec63"),
  patch: p("5073493"),
  switchBlue: p("2881232"),
  fiber: p("2881229"),
  noc: p("5380595"),
  gateway: g("3ad3c3f0b92857c013731a9efd150608937b0a80fff1f4ae3954498d92fe29b6"),
  ap: g("46e7da24cb43ffd460776c80452e9f4f3cb18744683b95ee464c5b64eb94b14d"),
  door: g("031079b02099da288f3693c2d51429ce7d4ba12c02308c31df301bf73d65209c"),
  uiUdmRack: "/ubiquiti/life-udm-rack.webp",
  uiUdmFront: "/ubiquiti/life-udm-rack-front.webp",
  uiSwitchRack: "/ubiquiti/life-switch-rack.webp",
  uiSwitchPatch: "/ubiquiti/life-switch-patch.webp",
  uiApCeiling: "/ubiquiti/life-ap-ceiling.webp",
  uiApTile: "/ubiquiti/life-ap-tile.webp",
  uiAccess: "/ubiquiti/life-access-door.webp",
  uiCamera: "/ubiquiti/life-camera-wall.webp",
};

export const NAV = [
  { id: "services", label: "Services" },
  { id: "unifi", label: "UniFi" },
  { id: "enterprise", label: "Enterprise" },
  { id: "process", label: "Process" },
  { id: "about", label: "About" },
];

// Site menu: every section, grouped by what a visitor is trying to do.
export const NAV_GROUPS = [
  {
    id: "services",
    label: "Services",
    items: [
      { id: "services", label: "Capabilities", desc: "Design, Wi-Fi, firewalls, SD-WAN, CCTV & support" },
      { id: "unifi", label: "UniFi platform", desc: "One dashboard, no licence fees" },
      { id: "enterprise", label: "Enterprise consultancy", desc: "Cisco, Palo Alto, Fortinet & Azure" },
    ],
  },
  {
    id: "why",
    label: "Why Lunar",
    items: [
      { id: "manifesto", label: "The Lunar method", desc: "Enterprise experience, small-business focus" },
      { id: "results", label: "Before & after", desc: "From spaghetti to standards" },
      { id: "process", label: "How it works", desc: "Survey, design, install, support" },
      { id: "about", label: "About", desc: "Certified engineer, one point of contact" },
    ],
  },
  {
    id: "tools",
    label: "Free tools",
    items: [
      { id: "wifi-planner", label: "Wi-Fi planner", desc: "Place access points, kill the dead zones" },
      { id: "health-check", label: "Security health check", desc: "10 questions, instant exposure score" },
      { id: "coverage", label: "Coverage checker", desc: "Do we cover your postcode?" },
    ],
  },
];

export const CERTS = [
  "Cisco CCNP Enterprise",
  "Palo Alto Networks",
  "Fortinet FortiGate",
  "Microsoft Azure",
  "Ubiquiti UniFi",
  "Cisco Meraki",
  "SD-WAN",
];

export const CHAPTERS = [
  {
    n: "01",
    title: "Designed once. Designed properly.",
    body: "Every network starts on paper — VLANs, addressing, coverage, failover. Enterprise discipline, sized for a business of ten or a hundred.",
  },
  {
    n: "02",
    title: "One pane of glass.",
    body: "Routing, Wi-Fi, cameras and doors on a single console. No juggling five vendors, no five logins, no recurring licence tax.",
  },
  {
    n: "03",
    title: "Security is the foundation, not the upsell.",
    body: "Segmentation, VPNs and threat management shaped by years on Palo Alto and FortiGate — baked into every install from day one.",
  },
  {
    n: "04",
    title: "An engineer, not a ticket queue.",
    body: "The person who designed your network is the person who answers when you call. Remote monitoring means most issues are gone before you notice.",
  },
];

export const SERVICES = [
  { id: "design", title: "Network design & installation", body: "Site surveys, topology design and clean installation — routing and switching built to enterprise standards.", tags: ["Routing", "Switching", "VLANs"], img: IMG.uiSwitchRack },
  { id: "wifi", title: "Wi-Fi & structured cabling", body: "Wireless surveys, precise AP placement and labelled, tidy cabling. Full coverage — no dead zones, no rat's nests.", tags: ["Wi-Fi 7", "Cat6A", "Fibre"], img: IMG.uiApTile },
  { id: "security", title: "Firewalls & cybersecurity", body: "Perimeter security, VPNs and threat prevention configured properly on Palo Alto, FortiGate or UniFi gateways.", tags: ["NGFW", "VPN", "IDS/IPS"], img: IMG.uiUdmRack },
  { id: "sdwan", title: "SD-WAN & multi-site", body: "Resilient links between branches and the cloud, with automatic failover that keeps every site online.", tags: ["SD-WAN", "Failover", "Azure"], img: IMG.fiber },
  { id: "cctv", title: "CCTV & door access", body: "IP cameras and door entry on the same UniFi platform as your network. One dashboard, zero extra vendors.", tags: ["Protect", "Access", "PoE"], img: IMG.uiCamera },
  { id: "support", title: "IT support & managed services", body: "Proactive monitoring, remote management and a direct line to the engineer who built it all.", tags: ["Monitoring", "Remote", "SLA"], img: IMG.noc },
];

export const STACK = [
  { id: "gateway", name: "Dream Machine Pro", role: "Cloud Gateway · NGFW · IDS/IPS · VPN", body: "The brain of the site. Routing, next-gen firewall, threat prevention and the UniFi console in a single rack-mount appliance.", img: IMG.uiUdmRack },
  { id: "switching", name: "Pro Max PoE Switching", role: "Layer 3 · PoE++ · 10G uplinks", body: "One cable powers and connects every access point, camera and door reader. Tidy racks, fewer sockets.", img: IMG.uiSwitchRack },
  { id: "wifi", name: "U7 Pro Access Points", role: "Wi-Fi 7 · 6 GHz · Seamless roaming", body: "Placed from a proper RF survey, not guesswork. Seamless roaming from the car park to the back office.", img: IMG.uiApCeiling },
  { id: "protect", name: "G5 Protect Cameras", role: "4K · Local storage · AI detection", body: "Cameras that record locally to your gateway — no cloud subscription and no separate NVR vendor to chase.", img: IMG.uiCamera },
  { id: "access", name: "G2 Pro Door Access", role: "NFC · Mobile keys · Intercom", body: "Readers and door hubs on the same console as your network. Add or revoke a key in seconds.", img: IMG.uiAccess },
  { id: "sitemagic", name: "Site Magic SD-WAN", role: "Mesh VPN · Multi-site · Failover", body: "Link branches together in a secure mesh with a few clicks — and keep them linked when a line drops.", img: IMG.uiUdmFront },
];

export const ENGAGEMENTS = [
  { id: "audit", k: "E/01", title: "Network audit & health check", body: "A full review of routing, switching, Wi-Fi and security posture — delivered as a prioritised remediation plan.", vendors: "Cisco · Meraki · UniFi" },
  { id: "sdwan", k: "E/02", title: "SD-WAN design & migration", body: "Legacy WAN to SD-WAN without dropping a site.", vendors: "Meraki · Fortinet · Cisco" },
  { id: "firewall", k: "E/03", title: "Firewall architecture & policy review", body: "Design, rulebase clean-up and segmentation done properly.", vendors: "Palo Alto · FortiGate" },
  { id: "azure", k: "E/04", title: "Azure hybrid networking", body: "vNets, site-to-site VPN and secure hybrid links between your offices and Azure.", vendors: "Microsoft Azure" },
  { id: "delivery", k: "E/05", title: "Project delivery with your IT team", body: "Hands-on design and implementation alongside in-house staff — knowledge transfer included.", vendors: "Multi-vendor" },
];

export const STEPS = [
  { n: "01", title: "Survey", body: "A site visit or call to map what you have, what's failing and what the business actually needs.", out: "Requirements & site notes" },
  { n: "02", title: "Design", body: "A clear proposal: topology, hardware list and a fixed price. No jargon, no padding.", out: "Topology + fixed quote" },
  { n: "03", title: "Install", body: "Clean installation, labelled cabling, tested end to end — scheduled around your working day.", out: "As-built documentation" },
  { n: "04", title: "Support", body: "Remote monitoring and a direct line to your engineer. Problems fixed before they reach you.", out: "Ongoing care" },
];

export const CREDENTIALS = [
  { name: "Cisco CCNP Enterprise", body: "Professional-level enterprise routing, switching and network design." },
  { name: "Palo Alto Networks", body: "Next-gen firewall architecture, policy and segmentation." },
  { name: "Fortinet FortiGate", body: "Secure SD-WAN and unified threat management." },
  { name: "Microsoft Azure", body: "Cloud computing and hybrid network connectivity." },
  { name: "Ubiquiti UniFi", body: "The full UniFi line — the core small-business platform." },
  { name: "Meraki & SD-WAN", body: "Cloud-managed, multi-site WAN design." },
];

export const SITE_TYPES = ["Office", "Retail", "Warehouse", "Multi-site", "Home"];
export const INTERESTS = ["Wi-Fi", "Cabling", "Firewall", "SD-WAN", "CCTV", "Door access", "Support", "Enterprise consult"];
